/**
 * Utility functions for portfolio comparison functionality
 */

export interface ComparisonPortfolioData {
    portfolioData1: any | null;
    portfolioData2: any | null;
    hasData: boolean;
}

/**
 * Create enriched comparison report parameters using v2 API
 * This combines two single portfolio parameters into a comparison structure
 */
export async function createComparisonReportParameters(
    fetchReportParameters: (portfolioId: string) => Promise<any>,
    portfolioId1: string,
    portfolioId2: string
): Promise<any> {
    const [params1, params2] = await Promise.all([
        fetchReportParameters(portfolioId1),
        fetchReportParameters(portfolioId2)
    ]);

    const responseMerged = JSON.parse(JSON.stringify(params1));
    const response2 = JSON.parse(JSON.stringify(params2));

    responseMerged.report_sections.scheda_prodotti2 = response2.report_sections.scheda_prodotti;

    responseMerged.report_sections.scheda_prodotti.title = "Schede Prodotto (Portafoglio 1)";
    responseMerged.report_sections.scheda_prodotti2.title = "Schede Prodotto (Portafoglio 2)";

    // Negoziabilità Fineco is a single-portfolio (manual upload) section — excluded from comparison reports.
    delete responseMerged.report_sections.negoziabilita_fineco;

    responseMerged.report_sections.portfolio_story.visible = responseMerged.report_sections.portfolio_story.visible || response2.report_sections.portfolio_story.visible;

    return responseMerged;
}

/**
 * Get filename for comparison PDF download
 */
export function getComparisonPdfFilename(portfolioId1: string, portfolioId2: string): string {
    return `portfolio-comparison-${portfolioId1}-${portfolioId2}.pdf`;
}
